require('jquery-ui/ui/widget');
require('jquery-ui/ui/position');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/unique-id');
require('jquery-ui/ui/widgets/tooltip');
// CUSTOM FORMS -----------------------------------------------------------------------

const initCustomForms = (target) => {
		$('input[type="checkbox"].custom', target).each(function() {
			$(this).after('<span></span>');
		});

		$('input[type="radio"].custom', target).each(function() {
			$(this).after('<span></span>');
		});
	}

const initCustomCheckboxes = (target, callback) => {
            var res = $('label input[type="checkbox"]', target);

            res.each(function(k, v) {
                $(v).change(function(e) {
                    customFormsClickHandler(target);
                    if(callback) callback($(v).attr('name'), $(v).is(':checked'));
                });
            })

            customFormsClickHandler(target);
	}

const initCustomRadios = (target, callback) => {
            var res = $('label input[type="radio"]', target);

            res.each(function(k, v) {
                $(v).change(function(e) {
                    customFormsClickHandler(target);
                    if(callback) callback($(v).attr('name'), $(v).val());
                });
            });

            customFormsClickHandler(target);
	}

const customFormsClickHandler = (target) => {
		$('label', target).each(function() {
			$('input', this).is(':checked') ? $(this).removeClass('unchecked') : $(this).addClass('unchecked');

            if($(this).data('block') != undefined) {
                $($(this).data('block')).css('display', $('input', this).is(':checked') ? 'block' : 'none');
            }
		});
	}

// TABS -------------------------------------------------------------------------------

    function initTabs(customTabWidth) {
		$('nav.tabs, nav.button-tabs').each(function() {
			var opened = false;
			var tabs = $(this).find('a');

            if(!customTabWidth) {
                $(tabs).width((tabs.length == 1) ? Math.floor($(this).width() / 2) : Math.floor($(this).width() / $(tabs).length));
            }

			$(tabs).each(function(index) {
				$(this).click(function() {
					$(tabs).each(function(ind) {
						if(index == ind) {
							$(this).addClass('active');
							$(this).parent().parent().find($(this).attr('href')).css('display', 'block');
						}
						else {
							$(this).removeClass('active');
							$(this).parent().parent().find($(this).attr('href')).css('display', 'none');
						}
					});

					return false;
				});

				if($(this).hasClass('active')) {
					opened = true;
					$(this).click();
				}
			});

			if(!opened) $($(tabs)[0]).click();
		});
	}

// MARQUEE ----------------------------------------------------------------------------

    (function($) {
        $.fn.getHiddenDimensions = function(includeMargin) {
            var $item = this,
                props = { position: 'absolute', visibility: 'hidden', display: 'block' },
                dim = { width:0, height:0, innerWidth: 0, innerHeight: 0,outerWidth: 0,outerHeight: 0 },
                $hiddenParents = $item.parents().addBack().not(':visible'),
                includeMargin = (includeMargin == null)? false : includeMargin;

            var oldProps = [];
            $hiddenParents.each(function() {
                var old = {};

                for ( var name in props ) {
                    old[ name ] = this.style[ name ];
                    this.style[ name ] = props[ name ];
                }

                oldProps.push(old);
            });

            dim.width = $item.width();
            dim.outerWidth = $item.outerWidth(includeMargin);
            dim.innerWidth = $item.innerWidth();
            dim.height = $item.height();
            dim.innerHeight = $item.innerHeight();
            dim.outerHeight = $item.outerHeight(includeMargin);

            $hiddenParents.each(function(i) {
                var old = oldProps[i];
                for ( var name in props ) {
                    this.style[ name ] = old[ name ];
                }
            });

            return dim;
        }
    }(jQuery));

    (function($) {
        $.fn.textWidth = function(){
            var temp = $('<span>' + $(this).text() + '</span>');
            temp.appendTo($('body'));
            temp.css({
                color: $(this).css('color'),
                display: 'none',
                fontFamily: $(this).css('fontFamily'),
                fontSize: $(this).css('fontSize'),
                fontStyle: $(this).css('fontStyle'),
                fontWeight: $(this).css('fontWeight'),
                textTransform: $(this).css('textTransform')
            });

            var width = temp.width();
            temp.remove();

            return width + 2;
        };

        $.fn.marquee = function(args) {
            var that = $(this);
            var textWidth = that.textWidth(),
            offset = that.getHiddenDimensions().width,

            css = {
                'text-indent' : that.css('text-indent'),
                'overflow' : that.css('overflow'),
                'white-space' : that.css('white-space')
            },
            marqueeCss = {
                'text-indent' : 0,
                'overflow' : 'hidden',
                'white-space' : 'nowrap'
            },
            args = $.extend(true, {
                count: -1,
                speed: 1,
                leftToRight: false
            }, args),
            i = 0,
            stop = offset - textWidth - 5,
            dfd = $.Deferred(),
            width = -args.speed,
            mover = false;

            if (stop >= 0) return;

            function go() {
                if (that.data('isStopped') != 1) {
                    if (!that.length) return dfd.reject();

                    that.css('text-indent', width + 'px');

                    if (width <= stop) {
                        args.leftToRight = true;
                        pause();
                        setTimeout(unpause, 1000);
                    } else if (width >= 0) {
                        args.leftToRight = false;
                        pause();
                        setTimeout(unpause, 1000);
                    }

                    if (args.leftToRight) {
                        width += args.speed;
                    } else {
                        width -= args.speed;
                    }

                    setTimeout(go, 30);
                }

                return 0;
            }

            function pause() {
                $(that).data('isStopped', 1);
            }

            function unpause() {
                if (!mover) return;
                $(that).data('isStopped', 0);
                go();
            }

            that.css(marqueeCss);

            that.bind('mouseover', function() {
                if (mover) return;
                mover = true;
                unpause();
            }).bind('mouseout', function() {
                if (!mover) return;
                mover = false;
                width = -1;
                that.css('text-indent', '0px');
                pause();
            });
            //unpause();

            return dfd.promise();
        };
    })(jQuery);

// READY ------------------------------------------------------------------------------

	$(document).ready(function() {
		initCustomForms($('body'));
        $('*[rel="tooltip"]').tooltip({ animation: false });

        $('.marquee').each(function (k, el) {
            $(el).marquee();
        });

        $(window).scroll();
	});


export { initCustomForms, initCustomCheckboxes, initCustomRadios, customFormsClickHandler, initTabs }
